<template>
  <div>
    <div class="files-gallery">
      <component
        v-for="file in shownFiles"
        :key="`${file.name}_${file.id}`"
        :is="file.type === FileType.IMAGE ? EImageLoadedCard : EFileLoadedCard"
        :file="file"
        :deleteable="deletable"
        mode="square"
        @delete="deleteFile(file.id)"
      />
    </div>
    <div v-if="files.length > maxFilesCount" class="link d-flex align-center font-600 mt-4" @click="toggleAllFiles">
      {{ isShowAllFiles ? 'Свернуть' : `Все фотографии (${files.length})` }}
      <e-icon class="ml-1" :name="isShowAllFiles ? 'chevronUp' : 'chevronDown'" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, toRef } from 'vue';
import { useDisplay } from 'vuetify';
import { EFileLoadedCard, EIcon, EImageLoadedCard } from '@/core/components/ui';
import { FileType, type LoadedFile } from '@/core/types/files';

const props = defineProps<{
  files: LoadedFile[];
  deletable?: boolean;
}>();

const emit = defineEmits<{
  (e: 'delete', id: string): void;
}>();

const $display = useDisplay();

const maxFilesCount = toRef(() => ($display.xs.value ? 6 : 10));
const isShowAllFiles = ref(false);

const shownFiles = computed(() => (isShowAllFiles.value ? props.files : props.files.slice(0, maxFilesCount.value)));

const toggleAllFiles = () => {
  isShowAllFiles.value = !isShowAllFiles.value;
};

const deleteFile = (id: string) => {
  emit('delete', id);
};
</script>

<style scoped lang="scss">
.files-gallery {
  display: grid;

  grid-gap: $gap-3;
  grid-template-columns: repeat(5, 1fr);

  @include sm-and-down {
    grid-template-columns: repeat(4, 1fr);
  }

  @include xs {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
